import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import FilterItem from './FilterItem';
import { useActiveFilters } from '../hooks/useActiveFilters';

const FilterItemList = ({ isReady }) => {
	const labels = useLabels();
	const { filters, handleFilterRemove, handleClearAllFilters } =
		useActiveFilters(isReady);

	return (
		<ul className="facet-filter-list mb-0 list-inline">
			{filters.map((filter) => (
				<li className="my-1" key={`${filter.type}-${filter.id}`}>
					<FilterItem
						{...filter}
						handleFilterRemove={handleFilterRemove}
					/>
				</li>
			))}
			{filters.length > 0 && (
				<li className="my-1">
					<button
						className="text-link"
						type="button"
						onClick={handleClearAllFilters}
					>
						{labels.get('CLEAR_FILTERS')}
					</button>
				</li>
			)}
		</ul>
	);
};

FilterItemList.propTypes = {
	isReady: PropTypes.bool.isRequired
};

export default FilterItemList;
